import React from "react";
import VesselList from "./VesselList";

const Vessel = () => {
  return (
    <>
      <VesselList />
    </>
  );
};

export default Vessel;
